import type React from 'react';
import { icons } from '../icons';
import cn from '../utils/cn';
import KoobNavbarAvatar from './KoobNavbarAvatar';

export default function KoobNavbarUser({
  name,
  organization,
  // Optional image hook for the future — no image lookup is done yet.
  imageUrl,
  // When true, the avatar shows a pulsing red ring (admin impersonating a user).
  impersonating = false,
  className,
  onClick,
  ...props
}: Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'name'> & {
  name?: string;
  organization?: string;
  imageUrl?: string;
  impersonating?: boolean;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'flex items-center gap-3 border-none bg-transparent rounded-lg px-2 py-1.5 transition hover:bg-gray-100 cursor-pointer',
        className,
      )}
      {...props}
    >
      {/* Avatar — initials only, pulsing red ring while impersonating */}
      <KoobNavbarAvatar
        name={name}
        imageUrl={imageUrl}
        impersonating={impersonating}
      />

      {/* Name + organization */}
      {/* Phones: the avatar alone, the bar has no room for the name. */}
      <span className="min-w-0 hidden sm:flex flex-col items-start text-left">
        <span className="text-sm font-bold text-k-h truncate max-w-[12rem]">
          {name}
        </span>
        {organization && (
          <span className="text-xs text-k-p truncate max-w-[12rem]">
            {organization}
          </span>
        )}
      </span>

      {/* Chevron — vertically centered */}
      <i
        className={cn(icons.chevronDown, 'fa-fw text-xs text-k-p self-center')}
      />
    </button>
  );
}
